import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogTitle,
    DialogTrigger,
} from "./ui/dialog";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";

const ConfirmationDialog = ({
    children,
    triggerButton,
    confirmText,
    confirmAction,
}) => {
    const [show, setShow] = useState(false);

    return (
        <div>
            <Dialog open={show} onOpenChange={setShow}>
                <DialogTrigger asChild>{triggerButton}</DialogTrigger>

                <DialogContent>
                    {children}

                    <DialogFooter>
                        <SecondaryButton onClick={() => setShow(false)}>
                            Cancel
                        </SecondaryButton>
                        <PrimaryButton
                            onClick={() => {
                                confirmAction();
                                setShow(false);
                            }}
                        >
                            {confirmText}
                        </PrimaryButton>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ConfirmationDialog;
